import script from "./listFileOfStudent.vue?vue&type=script&setup=true&lang=js"
export * from "./listFileOfStudent.vue?vue&type=script&setup=true&lang=js"

import "./listFileOfStudent.vue?vue&type=style&index=0&id=e3742e88&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3742e88"]])

export default __exports__